import React from 'react';
import Modal from 'react-modal';
import { ModalType } from 'enums';
import Popup from './PopUpBlockerWarning';
import Flash from './FlashWarning';
import BlackoutMap from './BlackoutMap';
import IframeAuth from '../activation/IframeAuth';

// empty the modal's default styles
Modal.defaultStyles = {};

// TODO: any way we can sync this with the css value?
export const HEADER_HEIGHT = 50;

export function getModalContent(type, data = {}, { headerHeight }) {
    let body = '';
    let title = '';
    let modalStyles = {
        height: 500
    };
    let bodyStyles = {
        marginLeft: '5%'
    };
    switch (type) {
        case ModalType.POPUP:
            title = 'Pop-up Blocked';
            body = <Popup />;
            break;
        case ModalType.FLASH:
            title = 'Flash not Enabled';
            body = <Flash />;
            break;
        case ModalType.BLACKOUT_MAP:
            title = 'Blackout Map';
            body = <BlackoutMap content={data.content} />;
            break;
        case ModalType.IFRAME_AUTH:
            title = 'Authentication';
            body = <IframeAuth src={data.src} />;
            modalStyles = {
                width: data.width,
                height: data.height + headerHeight,
                marginLeft: -(data.width / 2)
            };
            bodyStyles = {
                width: '100%',
                height: '100%',
                marginTop: -22
            };
            break;
        default:
            break;
    }
    return {
        title,
        body,
        modalStyles,
        bodyStyles
    };
}

const ModalMessaging = ({
    showModalMessage,
    closeModal,
    messageType,
    messageData
}) => {
    const {
        title,
        body,
        modalStyles,
        bodyStyles
    } = getModalContent(messageType, messageData, { headerHeight: HEADER_HEIGHT });

    return (
        // emulates the same mask used on .com when lightbox is opened
        <div>
            <Modal
                isOpen={showModalMessage}
                onRequestClose={closeModal}
                overlayClassName="lightbox-container"
            >
                <article className="lightbox-watch watch-provider-modal js-bloomed" style={modalStyles}>
                    <div className="btn-close icon-font-before icon-close-solid-before" onClick={closeModal} />
                    <section className="watchProvider--modal">
                        <h1 className="watchProvider__title">
                            <span>{title}</span>
                        </h1>
                        <div style={bodyStyles}>
                            {body}
                        </div>
                    </section>
                </article>
            </Modal>
        </div>
    );
};

ModalMessaging.propTypes = {
    closeModal: React.PropTypes.func,
    messageData: React.PropTypes.object,
    messageType: React.PropTypes.string,
    showModalMessage: React.PropTypes.bool
};

ModalMessaging.defaultProps = {
    showModalMessage: false,
    messageData: null
};

export default ModalMessaging;



// WEBPACK FOOTER //
// ./app/modal/messaging/ModalMessaging.js